module.exports = __webpack_public_path__ + "media/images/NcinoEsign-b8e4453f.svg";